/**
 * First page an authenticated session may open.
 * Skips overlay-denied pages and the production mock blocklist.
 */

import { CONFIG, isNavHiddenInProd } from "/assets/js/config.js";
import { guardPage } from "/assets/js/permission_control/permission-guards.js";

export const NO_ACCESS_PAGE = "sem-acesso.html";

/** Prefer live surfaces, then remaining operational pages. */
export const LANDING_CANDIDATES = Object.freeze([
  "atendimento.html",
  "pacientes.html",
  "catalogo.html",
  "parceiros.html",
  "painel.html",
  "agenda.html",
  "audio_fono.html",
  "manutencao.html",
  "relatorios.html",
  "financeiro.html",
]);

/**
 * @param {{ exclude?: string }} [options]
 * @returns {string} path relative to the app root (`pages/…`)
 */
export function resolveSessionLanding(options = {}) {
  const exclude = String(options.exclude || "")
    .trim()
    .toLowerCase()
    .replace(/^.*\//, "");
  for (const page of LANDING_CANDIDATES) {
    if (page === exclude) continue;
    const stem = page.replace(/\.html$/, "");
    if (CONFIG.STAGE === "prod" && isNavHiddenInProd(stem)) continue;
    if (!guardPage(page)) continue;
    return `pages/${page}`;
  }
  return `pages/${NO_ACCESS_PAGE}`;
}
